'use client';
import { createContext, use, useEffect } from 'react';

import { setTheme, Themes } from '@/theme/themeProviderUtils';

const ThemeContext = createContext<{
  theme: Themes;
}>({
  theme: 'light',
});

export function useTheme() {
  const context = use(ThemeContext);

  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }

  return context;
}

export default function ThemeProvider({
  children,
  theme,
}: {
  children: React.ReactNode;
  theme: Themes;
}) {
  useEffect(() => {
    setTheme(theme);
  }, [theme]);

  return <ThemeContext value={{ theme }}>{children}</ThemeContext>;
}
